export const colors = {
  primary: {
    main: '#0064FF',
    hover: '#000081',
    20: '#062788',
    60: '#2A62F6',
    80: '#DCEAFF'
  },
  secondary: '#FF0000',
  tertiary: '#FF8394',
  quartenary: '#F3F6FB',
  neutral: {
    black: '#1A1A1E', // NOTE: same as 90
    high: '#4A4A4B',
    medium: '#6C6D6E',
    light: '#8E8E8E',
    mediumhover: '#BCBCBC',
    lighthover: '#D2D2D2',
    clear: '#ECECEC',
    '100': '#F9F9F9',
    '700': '#454F5B',
    white: '#FFFFFF',
    wrapicon: '#F3F6FB',
    // Normalized with Figma
    20: '#F9F9F9',
    60: '#8E8E8E',
    50: '#808080',
    80: '#4A4A4B',
    90: '#1A1A1E'
  },
  support: {
    success: '#2CAC40',
    successhover: '#1E782C',
    warning: '#E58221',
    error: '#A0192A',
    disabled: '#B4D0FA',
    first: '#00917D',
    second: '#953FDB',
    third: '#AE482B',
    fourth: '#FF8394',
    red: '#AD0606',
    redhover: '#910808'
  },
  alert: {
    success: {
      10: '#F5FBF4',
      20: '#DFF3DC',
      30: '#229A16',
      40: '#1B7811',
      50: '#14560D',
      light: '#AAF27F',
      main: '#54D62C',
      dark: '#229A16', // NOTE: same as 30
      darker: '#08660D'
    },
    danger: {
      10: '#FFF6F4',
      20: '#FFD8CF',
      30: '#C93934',
      40: '#A83632',
      50: '#80221F',
      light: '#FFA48D',
      main: '#FF4842',
      dark: '#C93934', // NOTE: same as 30
      darker: '#A12E2A'
    },
    warning: {
      10: '#FFF5DD',
      20: '#FFE88E',
      30: '#EDA31D',
      40: '#D7900E',
      50: '#BC7900',
      light: '#FFE16A',
      main: '#FFC107',
      dark: '#EDA31D', // NOTE: same as 30
      darker: '#CF8D00'
    },
    info: {
      20: '#CDE6FF',
      40: '#003F98',
      ligther: '#E8F6FF',
      light: '#74CAFF',
      main: '#1890FF',
      dark: '#0C53B7',
      darker: '#04297A'
    }
  }
} as const
